import type { NavigateFunction } from 'react-router'

import {
  CLAIM_ERROR,
  CLAIM_REQUESTING,
  CLAIM_SUCCESS,
  DISABLE_INPUTS
} from './claim-constants'
import type { ClaimDetailsType } from './types'

const fetchClaim = (
  claim: string,
  dateOfLoss: string,
  redirectTo: string,
  recaptchaToken: string,
  // navigate is non-serializable and it is an antipattern in redux
  // to include it as part of the action. However, we need to navigate
  // in our saga, and this function is not set in state nor mutated, so
  // it should be okay to include it here.
  navigate: NavigateFunction
) => ({
  type: CLAIM_REQUESTING,
  claim,
  dateOfLoss,
  redirectTo,
  recaptchaToken,
  navigate
})

const claimError = (error?: unknown) => ({ type: CLAIM_ERROR, error })
const claimSuccess = (claimDetails: ClaimDetailsType) => ({ type: CLAIM_SUCCESS, claimDetails })
const disableInputs = () => ({ type: DISABLE_INPUTS, disable: true })
const enableInputs = () => ({ type: DISABLE_INPUTS, disable: false })

export {
  claimError,
  claimSuccess,
  disableInputs,
  enableInputs,
  fetchClaim
}
